export default __webpack_public_path__ + "static/media/menu5.2c2f4c9a.svg";